import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomerBillingOtherCustomerModel } from '../customer-billing-other-customer.model';
import { comparator } from '@fi-shared/utils/array-sort-comparators';
import { BillingContactModel } from '@fi-app/billing/billing-contact.model';
import { fiInvoiceMethodType } from '../../customer-billing-invoice/invoice-method-type';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { EditTabModel, EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { createMap } from '@fi-shared/utils/create-map';

@Component({
    selector: 'fi-customer-billing-other-customer-view',
    templateUrl: './customer-billing-other-customer-view.component.html',
    styleUrls: ['./customer-billing-other-customer-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-other-customer-view' },
    standalone: false,
})
export class CustomerBillingOtherCustomerViewComponent implements OnInit {
    @Input() customer: CustomerBillingOtherCustomerModel;
    @Input() resellers: CustomerBillingOtherCustomerModel[];
    ContactPerson: BillingContactModel;
    InvoiceMethodType = fiInvoiceMethodType;
    BillingReference: BillingContactModel;
    EditTabs: EditTabsModel;

    private resellersMap: {
        [key: string]: CustomerBillingOtherCustomerModel;
    };

    constructor(private stateService: FiStateService) {}

    ngOnInit() {
        this.setInitialData();
        this.setPageHeaderData();
    }

    private setInitialData() {
        this.ContactPerson =
            this.customer.Contacts.sort(comparator((item) => item.IsDefault, true))[0] || new BillingContactModel();
        this.BillingReference = this.customer.InvoiceInfo.BillingReference[0] || new BillingContactModel();
        this.resellersMap = createMap(this.resellers, 'Id');
    }

    private setPageHeaderData() {
        this.EditTabs = new EditTabsModel(this.customer.Name);
        this.EditTabs.Tabs.push(new EditTabModel('', ''));
    }

    editOtherCustomer() {
        this.stateService.go(FiStateNames.CustomerBilling.OtherCustomers.Edit, { Id: this.customer.Id });
    }

    getResellerName(resellerId: number): string {
        const reseller = this.resellersMap[resellerId];
        return reseller ? reseller.Name : this.customer.DefaultResellerName;
    }
}
